import helpers from '@/helpers'

import { fetch } from '../'

const getConfig = {
  taxonomy: 'categories',
  customfields: false
}
const getAllConfig = {
  taxonomy: 'categories',
  embed: false,
  customfields: false,
  body: {}
}

export default {
  async getAll (config = {}) {
    config = Object.assign({}, getAllConfig, config)
    if (window.lang) config.lang = window.lang
    if (config.embed) config.body._embed = true
    const body = helpers.createBody(config.body)
    let response = await fetch(`/wp-json/wpvue/v1/terms/${config.taxonomy}?${body}`)
    let data = await response.json()
    return response.ok ? data : []
  },

  async get (id, config = {}) {
    if (parseInt(id) && parseInt(id) == id) {
      return this.getById(id, config)
    } else {
      return this.getBySlug(id, config)
    }
  },

  async getById (id, config = {}) {
    config = Object.assign({}, getConfig, config)
    return this.privateGet(`/wp-json/wpvue/v1/terms/${config.taxonomy}/${id}${window.lang ? '?lang=' + window.lang : ''}`, config)
  },

  async getBySlug (slug, config = {}) {
    config = Object.assign({}, getConfig, config)
    return this.privateGet(`/wp-json/wpvue/v1/terms/${config.taxonomy}/${slug}?type=slug${window.lang ? '&lang=' + window.lang : ''}`, config)
  },

  async privateGet (url, config) {
    let response = await fetch(url)
    let data = await response.json()
    data = Array.isArray(data) ? data[0] : data
    if (response.ok && data) {
      // if (config.customfields) {
      //   let meta = await customfields.get(data.id)
      //   data.meta = meta
      //   return data
      // } else {
      //   return data
      // }
      return data
    } else {
      return null
    }
  }
}
